import { Modal, Button } from "react-bootstrap";
import React from "react";
import {
  CLOSE_WINDOW_TRY_AGAIN,
  FARMER_LOGIN_ERROR,
  LOGIN_SESSION_DID_NOT_OPEN,
} from "../../../configurations/MessageConstants";

function FarmerSessionError() {
  const handleClose = () => {
    window.close();
  };

  return (
    <div className="farmer-session-error">
      <Modal size="md" show={true} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {FARMER_LOGIN_ERROR}
            <i
              className="fa fa-exclamation-circle farmer-session-error-warning-icon"
              aria-hidden="true"
            ></i>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {LOGIN_SESSION_DID_NOT_OPEN} <br />
            {CLOSE_WINDOW_TRY_AGAIN}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleClose()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default FarmerSessionError;
